import { render } from "./HeaderProfile.vue?vue&type=template&id=3b605041&scoped=true"
import script from "./HeaderProfile.vue?vue&type=script&lang=js"
export * from "./HeaderProfile.vue?vue&type=script&lang=js"

import "./HeaderProfile.vue?vue&type=style&index=0&id=3b605041&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b605041"]])

export default __exports__